module.exports = __webpack_public_path__ + "static/media/infoIcon.4dc30584.svg";